import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatCardModule } from "@angular/material/card";
import { HttpClientModule } from "@angular/common/http";

import { SharedComponents } from "./shared/components";
import { MenuItemsContentComponent } from "./features/menu-items-content/menu-items-content.component";
import { ApiEndpointsService } from "./shared/services/api-endpoints.service";
import { ApiHttpService } from "./shared/services/api-http.service";
import { Constants } from "./config/constants";
import { ConfigService } from "./shared/services/base-service";

@NgModule({
  declarations: [AppComponent, MenuItemsContentComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatCardModule,
    MatFormFieldModule,
    MatToolbarModule,
    HttpClientModule,
    SharedComponents,
  ],

  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ConfigService) => () => config.init(),
      deps: [ConfigService],
      multi: true,
    },
    ApiEndpointsService,
    ApiHttpService,
    Constants,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
